// Standard YAML's Core schema.
// http://www.yaml.org/spec/1.2/spec.html#id2804923
//
// NOTE: JS-YAML does not support schema-specific tag resolution restrictions.
// So, Core schema has no distinctions from JSON schema is JS-YAML.


'use strict';


module.exports = require('./json');



//////////////////
// WEBPACK FOOTER
// ./~/js-yaml/lib/schema/core.js
// module id = 111
// module chunks = 0